<template>
  <div>
    <div class="d-flex justify-content-between mb-3">
      <h4 class="mb-0">{{ isThriveNews ? 'Thrive' : 'Company' }} News</h4>
      <router-link
        v-if="canConfigureNews"
        class="action-icon d-inline-block"
        v-b-tooltip="'Configure News'"
        :to="{name: 'news', params: {companyId}}"
      >
        <i class="fas fa-cog fa-fw"/>
      </router-link>
    </div>

    <div v-if="articles.length === 0" class="text-center text-muted py-5">
      {{ emptyText }}
    </div>
    <template v-else>
      <div
        v-for="(article, i) in articles"
        :key="article.id"
        :class="{'mt-4': i > 0}"
      >
        <strong v-if="article.displayTitle">{{ article.title }}<br/></strong>
        <div v-html="article.content"/>
      </div>
    </template>
  </div>
</template>

<script>
import { getActiveArticles, getCompanyNewsFeed } from '@/home/news-admin/news-service'
import exceptionMixin from '@/common/mixins/exception-mixin'
import { thriveFeedId } from '@/home/Home'
import userInfoMixin from '@/common/mixins/user-info-mixin'
import appFeatures from '../common/app-features'

export default {
  name: 'CompanyNews',
  mixins: [exceptionMixin, userInfoMixin],
  props: {
    companyId: {
      required: true,
      type: String
    },
    emptyText: {
      required: false,
      default: 'There is no news',
      type: String
    }
  },
  data: () => ({
    articles: []
  }),
  computed: {
    isThriveNews () {
      return this.companyId === thriveFeedId
    },
    canConfigureNews () {
      if (this.isThriveNews) {
        return this.isGranburyUser
      } else {
        return this.hasFeature(appFeatures.accessConfigurationOptions)
      }
    }
  },
  async created () {
    try {
      const feed = await getCompanyNewsFeed(this.companyId)
      if (feed && feed.articles) {
        this.articles = getActiveArticles(feed.articles).filter(it => it.status === 'ACTIVE')
      }
    } catch (e) {
      console.log('No News')
    }
  }
}
</script>
